<template>
	<div class="container">
		<div class="nav">
			<img src="../../assets/logo.png" alt="" class="nav-left">
			<div class="nav-right">
				<a :href="item.href" :class="{'active':selectIndex == index}" @click="selectIndex=index"
					v-for="(item,index) in navList" :key="index">{{ item.name }}</a>
			</div>
		</div>
		<div id="about">
			<img src="../../assets/about-bg.png" alt="" class="about-bg">
			<div class="down flex-c-s">
				<div class="down-ios flex-c-c">
					<img src="../../assets/android.png" alt="" class="down-icon">
					Android App
				</div>
				<div class="down-android flex-c-c">
					<img src="../../assets/ios.png" alt="" class="down-icon">
					IOS App
				</div>
			</div>
		</div>
		<div id="features">
			<div class="title-top">
				FEATURES
			</div>
			<div class="title">
				Powerful & Intuitive Features
			</div>
			<div class="fList">
				<div v-for="(item,index) in fList" ::key="index" class="fItem">
					<img :src="item.icon" alt="" class="icon">
					<div class="fItem-title">
						{{ item.title }}
					</div>
					<div class="fItem-desc">
						{{ item.desc }}
					</div>
				</div>
			</div>
		</div>
		<div id="screenshot">
			<div class="title-top">
				SCREENSHOT
			</div>
			<div class="title">
				All in One Tap
			</div>
			<div class="bgList">
				<img v-for="(item,index) in bgList" :key="index" :src=item alt="">
			</div>
		</div>
		<div id="contact">
			<img src="../../assets/contact-bg.png" alt="" class="bg">
			<div class="cont">
				Cook with Heart, Savor with Joy — Your Go-To Recipe App for Every Delicious Moment.
			</div>
			<div class="search flex-c-c">
				<div class="search-left flec-c-s">
					<img src="../../assets/email.png" class="email" alt="">
				Allcardplus@gmail.com
				</div>
				<div class="search-right flex-c-c">
					Contach
				</div>
			</div>
			<div class="policy-links">
				<a class="policy-link" href="https://aromaplate.uk/agreement/user.html" target="_blank" rel="noopener noreferrer">User Agreement				</a>
				<a class="policy-link" href="https://aromaplate.uk/agreement/privacy.html" target="_blank" rel="noopener noreferrer">Privacy Policy
				</a>
			</div>
			<div class="news">
				Copyright © 2025 ALLcard. All Rights Reserved
			</div>
		</div>
	</div>
</template>


<script setup>
	import { ref } from 'vue'
	import featuresIcon1 from '../../assets/features-icon1.png'
	import featuresIcon2 from '../../assets/features-icon2.png'
	import featuresIcon3 from '../../assets/features-icon3.png'
	import featuresIcon4 from '../../assets/features-icon4.png'
	import screenshotIcon1 from '../../assets/screenshot-iocn1.png'
	import screenshotIcon2 from '../../assets/screenshot-iocn2.png'
	import screenshotIcon3 from '../../assets/screenshot-iocn3.png'
	const navList = ref([{ name: 'About', href: '#about' }, { name: 'Features', href: '#features' }, { name: 'Screenshot', href: '#screenshot' }, { name: 'Contact', href: '#contact' }, { name: 'Contact Us', href: '#contact' }])
	const fList = ref([
		{
			icon: featuresIcon1,
			title: 'Vast Recipe Library',
			desc: 'Thousands of free, step-by-step recipes for all tastes and dietary needs.'
		},
		{
			icon: featuresIcon2,
			title: 'Smart Search',
			desc: 'Turn what you have into delicious meals in seconds.'
		},
		{
			icon: featuresIcon3,
			title: 'AI Customization',
			desc: 'Tailor recipes to your preferences, adjust portions.'
		},
		{
			icon: featuresIcon4,
			title: 'Meal Planning',
			desc: 'Simplify meal prep and shopping with smart tools.'
		}
	])
	const selectIndex = ref(0)
	const bgList = ref([screenshotIcon1, screenshotIcon2, screenshotIcon3])
</script>


<style lang="css" scoped>
	.container {
		background: #fff;
	}

	.nav {
		position: fixed;
		width: 100vw;
		padding: 0 2.36rem 0 2.44rem;
		box-sizing: border-box;
		top: 0.63rem;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		z-index: 999;
	}

	.nav-left {
		width: 2.2rem;
		height: 0.53rem;
	}

	.nav-right {
		display: flex;
		align-items: center;
		justify-content: space-around;
		margin-left: 2.5rem;
		width: 100%;

	}


	.nav-right a {
		font-family: ff400;
		font-weight: 400;
		font-size: 0.23rem;
		color: #212832;
		text-decoration: none;
		width: 1.83rem;
		height: 0.53rem;
		border-radius: 0.07rem;
		border: 0.01rem solid transparent;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.active {
		border: 0.01rem solid #212832 !important;
	}

	#about {
		position: relative;
		width: 100vw;
		height: 11.6rem;
		overflow: hidden;
	}

	.about-bg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100vw;
		flex-shrink: 0;
	}

	.down {
		position: absolute;
		left: 1.97rem;
		bottom: 1.56rem;
		z-index: 99;
	}

	.down-ios,
	.down-android {
		width: 2.4rem;
		height: 0.8rem;
		color: #fff;
		background: #FF7F68;
		border-radius: 0.13rem;
		font-family: ff500;
		font-weight: 500;
		font-size: 0.21rem;
		cursor: pointer;
	}

	.down-android {
		color: #14183E;
		background: #F2F2F2;
		margin-left: 0.53rem;
	}

	.down-icon {
		width: 0.27rem;
		height: 0.27rem;
		margin-right: 0.19rem;
	}

	#about .title-top {
		width: 100vw;
		font-family: ff600;
		font-weight: 600;
		font-size: 0.24rem;
		color: #5E6282;
		text-align: center;
		margin-top: 1.33rem;
		margin-bottom: 0.13rem;
	}

	#features .title {
		width: 100vw;
		font-family: ff800;
		font-weight: bold;
		font-size: 0.67rem;
		color: #14183E;
		text-align: center;
		line-height: 0.87rem;
	}

	.fList {
		display: flex;
		align-items: center;
		justify-content: space-around;
		width: 100vw;
		padding: 0 1.44rem 1.23rem 1.44rem;
		box-sizing: border-box;
		margin-top: 0.87rem;
	}

	.fItem {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 3.56rem;
		height: 4.19rem;
		background: #FFFFFF;
		/* 注意：box-shadow 的 offset 必须带单位，否则整条声明可能被浏览器判定为无效 */
		box-shadow: 0px 2px 0.04rem 0px rgba(0, 0, 0, 0), 0px 11px 9px 0px rgba(0, 0, 0, 0.01), 0px 27px 17px 0px rgba(0, 0, 0, 0.01), 0px 51px 34px 0px rgba(0, 0, 0, 0.01), 0px 86px 62px 0px rgba(0, 0, 0, 0.02), 0px 133px 1.07rem 0px rgba(0, 0, 0, 0.02);
		border-radius: 0.48rem;
		padding: 0.36rem 0.56rem 0.47rem 0.56rem;
		box-sizing: border-box;
	}

	.fItem .icon {
		width: 1.33rem;
		height: 1.33rem;
	}

	.fItem-title {
		font-family: ff500;
		font-weight: 500;
		font-size: 0.24rem;
		color: #1E1D4C;
		text-align: center;
		margin-top: 0.36rem;
		margin-bottom: 0.19rem;
		flex-wrap: nowrap;

	}

	.fItem-desc {
		font-family: ff500;
		font-weight: 500;
		font-size: 0.21rem;
		color: #5E6282;
		text-align: center;
	}

	#screenshot .title-top {
		font-family: ff600;
		font-weight: 600;
		font-size: 0.24rem;
		color: #5E6282;
		text-align: center;
		margin-bottom: 0.11rem;
	}

	#screenshot .title {
		width: 100vw;
		font-family: ff800;
		font-weight: bold;
		font-size: 0.67rem;
		color: #14183E;
		text-align: center;
		margin-bottom: 0.76rem;
	}

	.bgList {
		width: 100vw;
		padding: 0 2.67rem;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.bgList img {
		width: 4.19rem;
		height: 6.09rem;
	}

	#contact {
		position: relative;
	}

	#contact .bg {
		width: 100vw;
		height: 8.4rem;

	}

	.search {
		position: absolute;
		z-index: 10;
		top: 4.67rem;
		left: 50%;
		transform: translateX(-50%);
	}

	.search-left {
		width: 5.61rem;
		height: 0.91rem;
		background: #FFFFFF;
		border-radius: 0.13rem;
		display: flex;
		align-items: center;
		font-family: ff400;
		font-weight: 400;
		font-size: 0.19rem;
		color: #39425D;
	}

	.email {
		width: 0.28rem;
		height: 0.24rem;
		margin-left: 0.41rem;
		margin-right: 0.19rem;
	}

	.cont {
		width: 11.45rem;
		height: 1.44rem;
		font-family: ff600;
		font-weight: 600;
		font-size: 0.44rem;
		color: #5E6282;
		line-height: 0.72rem;
		position: absolute;
		top: 2.24rem;
		left: 50%;
		transform: translateX(-50%);
		text-align: center;
	}

	.search-right {
		width: 2.4rem;
		height: 0.91rem;
		background: linear-gradient(0deg, #FF946D 0%, #FF7D68 100%);
		border-radius: 0.13rem;
		font-family: ff400;
		font-weight: 400;
		font-size: 0.23rem;
		color: #FFFFFF;
		margin-left: 0.32rem;
	}

	.policy-links {
		position: absolute;
		z-index: 10;
		top: 6.02rem;
		left: 50%;
		transform: translateX(-50%);
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0.32rem;
	}

	.policy-link {
		height: 0.5rem;
		padding: 0 0.4rem;
		background: linear-gradient(0deg, #FF946D 0%, #FF7D68 100%);
		border-radius: 0.13rem;
		font-family: ff400;
		font-weight: 400;
		font-size: 0.23rem;
		color: #fff;
		text-decoration: none;
		display: flex;
		align-items: center;
		justify-content: center;
		white-space: nowrap;
	}

	.news {
		position: absolute;
		bottom: 0.57rem;
		width: 100vw;
		text-align: center;
		font-family: ff500;
		font-weight: 500;
		font-size: 0.19rem;
		color: #5E6282;
		line-height: 0.23rem;
	}
</style>